import { useQuery } from "@tanstack/react-query";
import { getBranches } from "../../service/query/auth";

export const useGetBranches= () => {
  const branches = useQuery({
    queryKey:["branches"],
    queryFn:async()=> getBranches(),
    enabled: true,
    staleTime: 0,
  },

);
  return {data:branches?.data?.data,  ...branches,}
};